import { render } from "./Footer.vue?vue&type=template&id=b1ae95ca&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=b1ae95ca&scoped=true&lang=scss"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ae95ca"]])

export default __exports__